import React from 'react';
import Reflux from 'reflux';
import Clock from 'shared/components/misc/clock.jsx';
import ServerTimeTickerStore from 'flux/stores/ServerTimeTickerStore';
import EventViewStore from 'flux/stores/EventViewStore';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

/**
 * ReadOnly Event Clock component
 */
export default React.createClass({
  displayName: 'EventClock',

  mixins: [
    Reflux.connect(ServerTimeTickerStore, 'date'),
    Reflux.connectFilter(EventViewStore, 'twentyFourHour', (event) =>
      event.get('twentyFourHourClock'),
    ),
    Reflux.connectFilter(EventViewStore, 'timeZone', (event) =>
      event.get('timeZone'),
    ),
  ],

  render() {
    const descriptionText = !this.props.hideDescription ? 'Time of Day' : '';

    return (
      <div className="event-clock">
        <Clock {...this.state} />
        <WithTooltip placement="bottom" tip={TooltipConstants.CSTimeOfDay}>
          <div className="event-clock__description">{descriptionText}</div>
        </WithTooltip>
      </div>
    );
  },
});
